import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UserSessionService } from 'bna-angular-auth-client';
import { Subscription, filter } from 'rxjs';
import { LocalStorageService } from 'src/app/core/services/data/local-storage.service';
import { NotificationService } from 'src/app/core/services/firebase/notification.service';
import { OrganizationService } from 'src/app/core/services/http/agency-mgmt/organization.service';
import { EventService } from 'src/app/core/services/http/event.service';
import { JobSearchService } from 'src/app/core/services/http/maintenance/job-search.service';
import { environment } from 'src/environments/environment';
import { EmailNotificationCount } from '../../models/email-notification-count.model';
import { SHOWORGANIZATIONEMAILCOUNT } from 'src/app/shared/constants/local-storage-items.constants';
import { ManagerService } from 'src/app/core/services/http/agency-mgmt/manager.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit, AfterViewInit {
  public invoiceProcessorEnabled = false;
  public keyAutomateEnabled = false;
  public isAssetRegisterViewEnabled = false;
  public isEnabledPowerBiQnA = false;
  public readonly invoiceAutomateUrl: string;
  public readonly keyAutomateUrl: string;
  unreadEmailCount = 0;
  hideInspectionManagerIcon = false;
  public pmUserIdList : EmailNotificationCount [] = null;
  public sub: Subscription[] = [];

  constructor(
    private userSessionService: UserSessionService,
    private organizationService: OrganizationService,
    private notificationService: NotificationService,
    private jobSearchService: JobSearchService,
    private localStorageService: LocalStorageService,
    private managerService: ManagerService
  ) {
    if (this.userSessionService.isAuthenticated()) this.loadStartupSettings();

    this.userSessionService.isAuthenticated$
      .pipe(filter((d) => d.isAuthenticated))
      .subscribe(() => {
        this.loadStartupSettings();
      });
      this.userSessionService.userHasChanged$.subscribe((changed) => {
        if (!this.userSessionService.isAuthenticated()) return;
        if (!changed) return;
        this.loadStartupSettings();
      });
    this.invoiceAutomateUrl = this.userSessionService.addSessionQueryParams(
      `${environment.invoiceProcessor.baseUrl}`
    );
    this.keyAutomateUrl = this.userSessionService.addSessionQueryParams(
      `${environment.keyAutomate.baseUrl}`
    );
  }

  ngOnInit(): void {
    this.notificationService.emailCount$.subscribe((data) => {
        this.unreadEmailCount = data;
      });
  }

  ngAfterViewInit() {
    let integrationType = localStorage.getItem('integration-type');
    this.hideInspectionManagerIcon = integrationType == 'IM';
  }

  ngOnDestroy(): void {
    this.sub.forEach(sub => sub.unsubscribe());
  }

  private loadStartupSettings() {
    if (this.sub[1]) this.sub[1].unsubscribe(); 
   this.sub[1] = this.organizationService.getStartupSettings()
   .subscribe((settings) => {
      let integrationType = localStorage.getItem('integration-type');
      this.invoiceProcessorEnabled =
        environment.invoiceProcessor.isEnable &&
        settings?.newInvoiceAutomateAppEnabled &&
        settings?.isCreditCardActivatedOrg && integrationType != 'IM';

      this.keyAutomateEnabled = environment.keyAutomate.isEnable && settings?.isKeyAutomateEnabled && integrationType != 'IM';
      this.isAssetRegisterViewEnabled = settings?.isAssetRegisterViewEnabled;
      this.isEnabledPowerBiQnA = settings?.isEnabledPowerBiQnA;
      console.log('environment.invoiceProcessor.isEnable - ' + environment.invoiceProcessor.isEnable);
      console.log('settings.newInvoiceAutomateAppEnabled - ' + settings?.newInvoiceAutomateAppEnabled);
      console.log('settings.isCreditCardActivatedOrg - ' + settings?.isCreditCardActivatedOrg);
      console.log('IA Enabled - ' + this.invoiceProcessorEnabled);
      
      console.log('environment.keyAutomate.isEnable - ' + environment.keyAutomate.isEnable);
      console.log('settings.isKeyAutomateEnabled - ' + settings?.isKeyAutomateEnabled);
      console.log('KA Enabled - ' + this.keyAutomateEnabled);
      
      console.log('integrationType - ' + integrationType);
      this.getUnreadEmailCount();

    });
  }

  getUnreadEmailCount(){
    this.managerService.getUnreadEmailCount().subscribe((count)=> {
      this.notificationService.setEmailCount(count);
    })
  }

  displayUnreadEmailNotificationCount() {
    if (!this.unreadEmailCount) this.unreadEmailCount = 0;

    return this.unreadEmailCount >= 99
      ? '99+'
      : this.unreadEmailCount.toString();
  }

  hiddenUnreadEmailCount() {
    return this.unreadEmailCount == 0;
  }

}
